<template>
  <!-- Фильтр блюд по тегам (Избранное, Рецепты, Ранее): горизонтальный ряд чипов. Показываем только
       теги, которыми размечено хотя бы одно блюдо, — пустой тег в фильтре
       даёт пустой экран. Выбрано несколько — блюдо должно иметь все. -->
  <div v-if="store.enabled && visibleTags.length" class="fav-tags" role="group" aria-label="Фильтр по тегам">
    <button type="button" class="fav-tag" :class="{ on: !modelValue.length }" @click="$emit('update:modelValue', [])">Все</button>
    <button
      v-for="tag in visibleTags" :key="tag" type="button"
      class="fav-tag" :class="{ on: modelValue.includes(tag) }" :aria-pressed="modelValue.includes(tag)"
      @click="toggle(tag)"
    >{{ tag }}</button>
  </div>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue'
import { useFavTagsStore } from '../store/favTags.js'

const props = defineProps({
  modelValue: { type: Array, default: () => [] },   // выбранные теги
  items: { type: Array, default: () => [] },        // блюда с полем tags
})
const emit = defineEmits(['update:modelValue'])
const store = useFavTagsStore()
onMounted(() => store.load())

const used = computed(() => {
  const s = new Set()
  for (const it of props.items) for (const t of it.tags || []) s.add(t)
  return s
})
// Порядок — как в списке пользователя
const visibleTags = computed(() => store.tags.filter(t => used.value.has(t)))

function toggle(tag) {
  const next = props.modelValue.includes(tag) ? props.modelValue.filter(t => t !== tag) : [...props.modelValue, tag]
  emit('update:modelValue', next)
}

// Выбранный тег исчез (сняли с последнего блюда, удалили в настройках) —
// убираем из фильтра, иначе список останется пустым без видимой причины
watch(visibleTags, (list) => {
  const next = props.modelValue.filter(t => list.includes(t))
  if (next.length !== props.modelValue.length) emit('update:modelValue', next)
})
</script>

<script>
// Подходит ли блюдо под выбранные теги (все сразу)
export function matchesTags(item, selected) {
  if (!selected?.length) return true
  const tags = item.tags || []
  return selected.every(t => tags.includes(t))
}
</script>

<style scoped>
.fav-tags {
  display: flex;
  /* Ряд стоит в flex-колонке окна добавления, а блок с прокруткой там
     сжимается до нуля — карточки наезжали на теги (5.10.2026) */
  flex: none;
  min-height: 42px;
  align-items: flex-start;
  gap: 6px;
  overflow-x: auto;
  /* Докрутили ряд до края — прокрутка не передаётся родителю: лента окна
     добавления уезжала вбок (27.10.2026) */
  overscroll-behavior-x: contain;
  padding-bottom: 10px;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
}
.fav-tags::-webkit-scrollbar { display: none; }
.fav-tag {
  flex: none;
  height: 32px;
  padding: 0 13px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid var(--line);
  color: var(--ink);
  font-family: Inter, sans-serif;
  font-size: var(--fs-13);
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  transition: background 0.15s, color 0.15s, border-color 0.15s, transform 0.1s;
}
.fav-tag:active { transform: scale(0.96); }
.fav-tag.on {
  background: var(--ink);
  border-color: var(--ink);
  color: var(--cream);
  font-weight: 600;
}
</style>
